import React from 'react';
import withPageComponents from '../../page/components/with-page-components';

import { ContentCardBanner } from '@hpstellar/core';
import { getBannerContentArray } from '../../utility/setHtml';

const leftRailBanner = ({ vwaLeftnavBanner }) => {
    if (!vwaLeftnavBanner || !vwaLeftnavBanner.banners) return null;

    return (
        <ContentCardBanner
            className="leftRailBanner"
            {...vwaLeftnavBanner}
            banners={getBannerContentArray(vwaLeftnavBanner.banners)}
            isSidebarBanner
            useMobileStyles
        />
    );
};

export default withPageComponents(leftRailBanner, { components: ['vwaLeftnavBanner'] });
